<template>
  <div class="user-info-wrapper">
    <div class="user-info" v-show="!isPassword">
      <div class="title">
        <img src="@imgs/back_mobile.png" @click="goBack()" />
        <span>修改信息</span>
      </div>
      <div class="content">
        <div class="info-item">
          <span>头像</span>
          <label class="uploadlogoButton" for="headPhoto">
            <img :src="headPic ? headPic : require('@imgs/personalPage/head-pic.png')" />
          </label>
          <input type="file" id="headPhoto" ref="headPhoto" value="imgFile" accept="image/png, image/jpg, image/jpeg" @change="uploadPhoto($event)" style="display: none" />
        </div>
        <div class="info-item">
          <span>名字</span>
          <div class="name">
            <input class="name-input" v-model="userName" />
            <el-button class="head-button" @click="saveUserData">保存</el-button>
          </div>
        </div>
        <div class="change-password" @click="isPassword = !isPassword">
          <span>修改密码</span>
        </div>
      </div>
    </div>
    <div class="change-password" v-show="isPassword">
      <div class="title">
        <img src="@imgs/back_mobile.png" @click="isPassword = !isPassword" />
        <span>修改密码</span>
      </div>
      <div class="setting-container">
        <div class="info-item">
          <span>原密码 <span class="red">*</span></span>
          <el-input placeholder="请输入您原密码" class="password-input" type="password" v-model="originPsw"></el-input>
        </div>
        <div class="info-item">
          <span>新密码 <span class="red">*</span></span>
          <el-input placeholder="请输入新密码 " class="password-input" type="password" v-model="newPassword"></el-input>
        </div>
        <div class="info-item">
          <span>再次输入 <span class="red">*</span></span>
          <el-input placeholder="请再次输入新密码" class="password-input" type="password" v-model="confirmPassword"></el-input>
        </div>
      </div>
      <a class="forget-password" :href="href">忘记密码</a>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="savePassword()">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      userName: '',
      headPic: '',
      type: 'info',
      isPassword: false,
      originPsw: '',
      newPassword: '',
      confirmPassword: '',
      href: window.location.origin + '/toResetPassword.jhtml?service=' + window.encodeURIComponent(window.location.href)
    }
  },
  methods: {
    saveUserData() {
      this.$emit('changeUserName', this.userName)
    },
    savePassword() {
      if (this.originPsw === '' || this.newPassword === '' || this.confirmPassword === '') {
        this.$message({
          message: '密码不能为空',
          type: 'error'
        })
        return
      }
      if (this.newPassword != this.confirmPassword) {
        this.$message({
          message: '确认密码不一致',
          type: 'error'
        })
        return
      }
      this.$emit('savePassword', this.originPsw, this.confirmPassword)
    },
    uploadPhoto(e) {
      this.$emit('uploadPhoto', e)
    },
    goBack() {
      this.$emit('goBack', 'info')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  padding: 0 20px;
  .title {
    font-weight: 600;
    text-align: center;
    height: 60px;
    font-size: 16px;
    color: #000000;
    line-height: 60px;
    width: 100%;
    padding: 0 20px;
    position: relative;
    border-bottom: #eaeaea 1px solid;
    img {
      width: 30px;
      vertical-align: middle;
      position: absolute;
      left: 10px;
      top: 15px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    .change-password {
      margin-top: 20px;
      cursor: pointer;
    }
  }
  .info-item {
    display: flex;
    height: 60px;
    justify-content: space-between;
    border-bottom: #eaeaea 1px solid;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    .name {
      font-size: 16px;
      color: #515151;
      font-weight: 600;
      .name-input {
        text-align: right;
        border: none;
        font-size: 16px;
        font-weight: 600;
        color: #515151;
      }
    }
    .head-button {
      width: 60px;
      height: 40px;
      background: #df5813;
      border-radius: 3px;
      font-size: 14px;
      color: #fff;
      padding: 12px;
      margin-left: 20px;
    }
    .red {
      color: #df5813;
    }
  }
  .el-input {
    border: none;
    width: 250px;
  }
  .setting-container {
    margin-bottom: 20px;
  }
  .forget-password {
    color: #df5813;
    font-size: 16px;
  }
  .default-edit-footer {
    height: 50px;
    line-height: 36px;
    font-size: 14px;
    padding-top: 10px;
    background-color: #ffffff;
    text-align: center;

    .edit-footer-item {
      cursor: pointer;
      display: inline-block;
      height: 36px;
      border: 1px solid #df5813;
      text-align: center;
      width: 100px;
      background-color: #df5813;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.password-input {
  input {
    border: none;
    text-align: right;
  }
}
</style>
